module.exports = __webpack_public_path__ + "static/img/5.23929cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/5.png
// module id = us0Q
// module chunks = 0